import { Component, inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'fz-force-kyc',
  templateUrl: './force-kyc.html',
  styleUrls: ['./force-kyc.scss'],
  standalone: true,
  imports: [MatButton],
})
export class ForceKycDialog {
  #ref = inject(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  handleContinueToKyc() {
    this.#ref.close();
  }
}
